module.exports = require('./picker.vue');


//////////////////
// WEBPACK FOOTER
// ./~/_vue-3d-picker@2.1.0@vue-3d-picker/src/index.js
// module id = 51
// module chunks = 17